module.exports = __webpack_public_path__ + "media/packs/images/partners/partner5-461dfdf28f401423a748a9ed34829db0.jpg";